export const google = {
  name: 'Google',
  id: 'google',
  url: 'https://www.google.com/',
  color: '#fff',
  compatible: false
}
